/**
 * GP-1365 — reach-out attempt outcomes offered on a Task Queue task, mirroring
 * the backend enum in `backend-v2/src/manual-tasks/enums/outreach-outcome.enum.ts`
 * (same mirroring convention as TASK_TYPES in services/taskQueueService).
 * The server validates the code, so the two lists must change together.
 */
export const OUTREACH_OUTCOMES = [
  { value: 'called_no_answer', label: 'Called - no answer' },
  { value: 'left_voicemail', label: 'Left voicemail' },
  { value: 'emailed', label: 'Emailed' },
  { value: 'texted', label: 'Texted' },
] as const;

export type OutreachOutcomeValue = (typeof OUTREACH_OUTCOMES)[number]['value'];

export const getOutreachOutcomeLabel = (value: string): string =>
  OUTREACH_OUTCOMES.find((o) => o.value === value)?.label || value;

/**
 * Quick-defer presets, in days from today. The counselor's stated workflow is
 * "try again in three or four days"; anything else goes through the date picker.
 * A preset that would land after the linked delivery date is disabled rather
 * than silently clamped — the counselor has to see the constraint.
 */
export const OUTREACH_SNOOZE_PRESET_DAYS = [3, 4] as const;

/**
 * At or above this many logged attempts the dialog stops treating another defer
 * as routine and prompts to escalate instead (ticket: "so repeated no-contact
 * tasks can be escalated rather than deferred indefinitely").
 */
export const OUTREACH_ESCALATION_THRESHOLD = 3;
